import React from 'react'
import UserHistory from "./UserHistory"
const index = (props) => {
  return (
    <div><UserHistory props={props}/></div>
  )
}

export default index